import PaginatedStore from "./base/PaginatedStore";

export const DEFAULT_SORT = { probability: "desc" };
const API_URL = "/api/initiatives/opportunities";

const { store, fetchList, reset, setFilters, setHiddenColumns, setLoading, setPageIndex, setPagingInfo, setPerPage, setSelectedData, setSort } = PaginatedStore({
    key: "initiativeOpportunities",
    label: "opportunities",
    apiListUrl: API_URL,
    defaultSort: DEFAULT_SORT,
    persistPagingInfo: false,
    storageKey: API_URL,
});

export const InitiativeOpportunitiesStore = store;
export const fetchInitiativeOpportunities = fetchList;

export const setOpportunityStatus = (projectKey, status, dismissReasonId) => {
    store.update((s) => {
        s.initiativeOpportunities = s.initiativeOpportunities.map((r) =>
            r.projectKey === projectKey
                ? { ...r, opportunityStatus: status, ...(dismissReasonId !== undefined ? { dismissReasonId } : {}) }
                : r
        );
        return s;
    });
};

export const setUserFlagged = (projectKey) => {
    store.update((s) => {
        s.initiativeOpportunities = s.initiativeOpportunities.map((r) =>
            r.projectKey === projectKey ? { ...r, userFlagged: true } : r
        );
        return s;
    });
};

export { reset, setFilters, setHiddenColumns, setLoading, setPageIndex, setPagingInfo, setPerPage, setSelectedData, setSort };
